export default function capitalize(value) {
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
}
